import { Component, OnInit } from '@angular/core';
import { IAgent } from '../../../models/agents.models';
import { distinctUntilChanged, filter, Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import * as AgentSelectors from '../../../store/agents.selectors';
import { AgentInformationsEditDialogComponent } from './agent-informations-edit-dialog/agent-informations-edit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as agentsActions from '../../../store/agents.actions';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-agent-informations',
  templateUrl: './agent-informations.component.html',
  styleUrls: ['./agent-informations.component.scss']
})
export class AgentInformationsComponent implements OnInit {
  agent$: Observable<IAgent | null> = this.store.select(
    AgentSelectors.selectAgent
  );
  agent: IAgent | null = null;

  destroy$ = new Subject<void>();

  constructor(private store: Store<AppState>, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.agent$
      .pipe(
        filter((agent) => agent != null),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((agent: IAgent | null) => {
        this.agent = agent;
      });
  }

  edit() {
    this.dialog.open(AgentInformationsEditDialogComponent, {
      data: {
        agent: this.agent
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  enableOrDisableAccess(event: MatSlideToggleChange) {
    this.store.dispatch(
      agentsActions.UpdateAgent({
        id: this.agent!.id!,
        agent: { is_user: event.checked },
      })
    );
  }
}
